import { render, staticRenderFns } from "./MissingProducts.vue?vue&type=template&id=b8ac46d0&scoped=true&"
import script from "./MissingProducts.vue?vue&type=script&lang=js&"
export * from "./MissingProducts.vue?vue&type=script&lang=js&"
import style0 from "./MissingProducts.vue?vue&type=style&index=0&id=b8ac46d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ac46d0",
  null
  
)

export default component.exports